import React from 'react';
import {useLocation, useNavigate } from 'react-router-dom';

const Footer = () => {
    
    const location = useLocation();
    const navigate = useNavigate();

    const handleClick = (link) => {
        navigate('/' + link)

       }
    
    return (
        <div className="bnb_menu">
                      
            <div className="bnbm" onClick={()=> handleClick('home')}>
                <b className={location.pathname ==="/home"?"bnbon":""}>
                        <p><img src={process.env.PUBLIC_URL + "/images/icon_home.svg"} alt="" /></p>
                        <span>HOME</span>
                </b>
            </div>
            
            <div className="bnbm" onClick={()=> handleClick('market')} >
            <b className={location.pathname ==='/market'?"bnbon":""}>
                <p><img src={process.env.PUBLIC_URL + "/images/icon_graph.svg"} alt="" /></p>
                <span>Market</span>
            </b>
            </div>
            <div className="bnbm"onClick={()=> handleClick('news')} >
            <b className={location.pathname ==='/news'?"bnbon":""}>
                <p><img src={process.env.PUBLIC_URL + "/images/icon_news.svg"} alt="" /></p>
                <span>News</span>
            </b>
            </div>
            <div className="bnbm" onClick={()=> handleClick('mypage')} >
            <b className={location.pathname ==='/mypage'?"bnbon":""}>
                <p><img src={process.env.PUBLIC_URL + "/images/icon_mypage.svg"} alt="" /></p>
                <span>My page</span>
            </b>
            </div>
            
        </div>
    );
}

Footer.propTypes = {};

export default Footer;
